import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ resource, calendar, nextCalendar }) =>
    present(
      repository
        .editResourceWeeklyCalendar(resource, calendar, nextCalendar)
        .then(() => ({
          resource,
          calendar,
          nextCalendar,
        }))
        .catch(() =>
          Promise.reject({
            resource,
            calendar,
            nextCalendar,
          }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
